import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseEdge, EdgeLabelRenderer, getBezierPath, useReactFlow, } from "reactflow";
/**
 * Custom edge that exposes a × button at the midpoint when the edge is
 * selected, plus a wider invisible hit area so it's easy to click.
 */
export function DeletableEdge(props) {
    const { id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, selected, style, markerEnd, } = props;
    const [edgePath, labelX, labelY] = getBezierPath({
        sourceX, sourceY, targetX, targetY,
        sourcePosition, targetPosition,
    });
    const { setEdges } = useReactFlow();
    return (_jsxs(_Fragment, { children: [_jsx(BaseEdge, { path: edgePath, markerEnd: markerEnd, style: style, interactionWidth: 24 }), selected && (_jsx(EdgeLabelRenderer, { children: _jsx("button", { type: "button", onClick: (e) => {
                        e.stopPropagation();
                        setEdges((eds) => eds.filter((edge) => edge.id !== id));
                    }, className: "rf-edge-delete pointer-events-auto absolute grid h-5 w-5 place-items-center rounded-full border border-ink-900 bg-accent-500 text-ink-900 shadow ring-1 ring-accent-300 hover:bg-accent-400", style: {
                        transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
                    }, "aria-label": "delete connection", children: "\u00D7" }) }))] }));
}
export const EDGE_TYPES = {
    default: DeletableEdge,
};
